import type { GeoJSON, Point } from 'leaflet';

export function isFeatureType<T extends IdentifyFeatureType>(
  feature: any,
  type: T,
): feature is Extract<IMapFeature, { type: T }> {
  return feature?.type === type;
}

export enum IdentifyFeatureType {
  Parcel = 'parcel',
  SurveyLabel = 'survey-label',
  SurveyMark = 'survey-mark',
  Road = 'road',
  Feature = 'feature',
}

interface ISingleParcel {
  id: string | number;
  spi: string;
}

export interface IParcelFeature extends IBaseMapFeature {
  type: IdentifyFeatureType.Parcel;
  geometry: GeoJSON.MultiPolygon;
  parcels: ISingleParcel[];
  vPfis: string[];
}

export interface ISurveyLabelFeature extends IBaseMapFeature {
  type: IdentifyFeatureType.SurveyLabel;
  name: string;
  id: string | number;
  code: string;
  wmsLayer?: string;
  geometry: GeoJSON.LineString;
}

export interface ISurveyMarkFeature extends IBaseMapFeature {
  type: IdentifyFeatureType.SurveyMark;
  name: string;
  id: number;
  geometry: GeoJSON.Point;
}

export interface IRoadFeature extends IBaseMapFeature {
  type: IdentifyFeatureType.Road;
  name: string;
  locality: string;
  id: number;
  geometry: GeoJSON.LineString;
}

export interface IPlaceFeature extends IBaseMapFeature {
  type: IdentifyFeatureType.Feature;
  name: string;
  id: number;
  vicmap_id: number;
}

export type IMapFeature =
  | IParcelFeature
  | ISurveyLabelFeature
  | ISurveyMarkFeature
  | IRoadFeature
  | IPlaceFeature;

export interface GeoserverCRS {
  type: string;
  properties: { name: string };
}
export const GEOSERVER_CRS: GeoserverCRS = {
  properties: {
    name: 'urn:ogc:def:crs:EPSG::7899',
  },
  type: 'name',
};

interface IBaseMapFeature {
  // query: string,
  geometry: GeoJSON.Geometry;
  coords: Point;
  crs: GeoserverCRS;
}

export interface GeoserverQueryResult<T extends GeoJSON.GeometryObject>
  extends GeoJSON.FeatureCollection<T> {
  crs: GeoserverCRS;
}

export interface IBulkDownloadableFeature {
  displayName: string;
  id: string;
  type: 'surveyMark' | 'surveyLabel';
}

export type DocStatusItem = Omit<IBulkDownloadableFeature, 'displayName'>;

export interface DocStatusItemWithGeom extends Omit<DocStatusItem, 'type'> {
  geometry: GeoJSON.FeatureCollection<GeoJSON.Point | GeoJSON.LineString>;
  crs: GeoserverCRS;
}
